module.exports = __webpack_public_path__ + "static/media/winLarge91_1.50463ab7.png";